import { core } from '@musinsa/pbo-core'
import { PBO_WARNING_ICON } from '@/components/pbo/pboDialog'
import type { EtcOutboundConfirmRes } from '@/services/outbound/outboundEtc/types'

/**
 * 확정 후 미할당 안내 (기타출고 UI 스펙 「확정 후 미할당 안내 모달」).
 *
 * `core.Modal.warning` 을 쓴다 — 마스크 클릭으로 닫히지 않고 [확인] 이나 ESC 로 닫힌다.
 * 아이콘만 DS 공통 에셋으로 바꾼다(antd 기본 글리프를 두면 이 모달만 옛 아이콘이 남는다 — 알럿·확인창과 같은 PBO_WARNING_ICON).
 * 메뉴 경로는 안내 문구일 뿐 링크가 아니다(미할당 처리 메뉴는 gi26).
 */
export const showUnallocatedNotice = (total: number, unallocated: number): void => {
  core.Modal.warning({
    icon: PBO_WARNING_ICON,
    title: `미할당 예상 ${unallocated}건`,
    content: (
      <>
        <div>
          확정 주문 {total}건 중 재고 부족으로 미할당이 예상되는 건은 {unallocated}건입니다.
        </div>
        <div>
          실제 결과는 <strong>출고 &gt; 미할당 처리</strong> 메뉴에서 확인하세요.
        </div>
        <core.Typography.Text type="secondary">내역 조회까지 최대 10분이 걸릴 수 있습니다.</core.Typography.Text>
      </>
    ),
    okText: '확인',
  })
}

/** 응답의 미할당 건수가 1건 이상일 때만 안내한다. 필드가 없으면(서버가 아직 안 채우면) 안내하지 않는다. */
export const notifyUnallocated = (res: Pick<EtcOutboundConfirmRes, 'totalCount' | 'unallocatedCount'>, fallbackTotal: number): void => {
  const unallocated = res.unallocatedCount
  if (typeof unallocated !== 'number' || unallocated < 1) return
  showUnallocatedNotice(res.totalCount ?? fallbackTotal, unallocated)
}
